import fetch from './fetch';
import { cmxExpApi } from 'endpoints';

export const fetchGql = async ( gqlString, variables = null ) => {
    const body = {
        query: gqlString,
        variables
    };

    const res = await fetch( `${ cmxExpApi }/graphql`, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify( body )
    } );

    return res.json();
};